export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      icon: 'ri-file-edit-line',
      title: 'Create Quote',
      description: 'Build professional quotes in minutes with our AI-powered templates and smart pricing tools. Upload photos and let AI calculate materials.',
      bgColor: 'bg-white'
    },
    {
      number: '02',
      icon: 'ri-send-plane-line',
      title: 'Send Invoice',
      description: 'Convert approved quotes to invoices instantly and send them with one click. Track delivery and view status in real-time.',
      bgColor: 'bg-slate-50'
    },
    {
      number: '03',
      icon: 'ri-money-dollar-circle-line',
      title: 'Get Paid',
      description: 'Accept payments online, track what\'s owed, and get paid faster than ever. Automated reminders keep cash flowing.',
      bgColor: 'bg-white'
    },
    {
      number: '04',
      icon: 'ri-map-pin-line',
      title: 'Track Jobs',
      description: 'Monitor your team in real-time with GPS tracking. Schedule jobs, assign workers, and stay on top of every project.',
      bgColor: 'bg-slate-50'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-100 rounded-full text-sm font-semibold text-amber-900 mb-6">
            <i className="ri-lightbulb-line"></i>
            Simple Process
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            How It Works
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Four simple steps to streamline your construction business
          </p>
        </div>

        {/* Steps Grid with Alternating Layout */}
        <div className="space-y-0">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`${step.bgColor} py-16 transition-all duration-300 hover:shadow-lg`}
            >
              <div className="max-w-6xl mx-auto px-6">
                <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}>
                  {/* Content */}
                  <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                    <div className="flex items-center gap-4 mb-6">
                      <div className="w-20 h-20 bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl flex items-center justify-center shadow-xl">
                        <i className={`${step.icon} text-4xl text-white`}></i>
                      </div>
                      <div className="text-7xl font-bold text-amber-500/20">
                        {step.number}
                      </div>
                    </div>
                    <h3 className="text-3xl font-bold text-slate-900 mb-4">
                      {step.title}
                    </h3>
                    <p className="text-lg text-slate-600 leading-relaxed">
                      {step.description}
                    </p>
                  </div>

                  {/* Visual Element */}
                  <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                    <div className="relative">
                      <div className="aspect-video bg-gradient-to-br from-slate-100 to-slate-200 rounded-2xl shadow-2xl overflow-hidden border-4 border-white">
                        <img
                          src={`https://public.readdy.ai/ai/img_res/948a13f1eb402f8ff16472e217608fb6.jpg${
                            index === 0 ? 'professional construction quote document on tablet device clean modern interface simple background' :
                            index === 1 ? 'construction invoice being sent via email on laptop screen clean modern interface simple background' :
                            index === 2 ? 'online payment processing on mobile phone construction business simple background' :
                            'GPS tracking map showing construction workers locations on tablet device simple background'
                          }&width=800&height=500&seq=how-it-works-${index + 1}&orientation=landscape`}
                          alt={step.title}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      {/* Decorative element */}
                      <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-amber-500 rounded-2xl opacity-20 blur-2xl"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16 pt-16 border-t border-slate-200">
          <h3 className="text-2xl font-bold text-slate-900 mb-4">
            Ready to streamline your business?
          </h3>
          <p className="text-lg text-slate-600 mb-8">
            Join hundreds of tradies saving 10+ hours per week
          </p>
          <a
            href="/signup"
            className="inline-flex items-center gap-2 px-8 py-4 bg-amber-600 text-white font-bold rounded-lg hover:bg-amber-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
          >
            Start Free Trial
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}